import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Upload, Col, Row, Select, TimePicker, DatePicker } from 'antd';
import AddDrawer from '../../component/AddDrawer';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';
import ImageUpload from '../../utils/ImageUpload';
import { addModules, editModules, getModules } from '../../feature/modules/moduleSlice';
import { toBase64 } from '../../utils/ImageConvert';



function EditModule({ editData }) {
    const { quickAccessIcon, quickAccessName, _id } = editData || {}
    const [uploader, setUploader] = useState(null)
    const { actionLoader } = useSelector((state) => state.modules);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        form.setFieldsValue({
            quickAccessName,
            quickAccessIcon
        })
    }, [open])

    const onFinish = async (values) => {
        // const base64Files = toBase64(quickAccessIcon)
        console.log("values", values)

        const formData = new FormData();
        formData.append("quickAccessId", _id);
        formData.append("quickAccessName", values.quickAccessName);
        if (uploader) {
            values.quickAccessIcon.forEach((file) => {
                formData.append("quickAccessIcon", file.originFileObj);
            });
        }
        const resultAction = await dispatch(editModules(formData));
        if (editModules.fulfilled.match(resultAction)) {
            await dispatch(getModules({}));
            form.resetFields();
            setOpen(false);
        } else {
            console.error("Add modules");
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };

    const AddForm = (
        <Form
            layout="vertical"
            form={form}
            name="add-service-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >

            <Form.Item
                name="quickAccessName"
                label="Module Name"
                rules={[{ required: true, message: 'Please enter  module name ' }]}
            >
                <Input placeholder='Enter Module Name' />
            </Form.Item>
            <Form.Item
                name="quickAccessIcon"
                label="Upload Document  "
                rules={[{ required: true, message: 'Please Upload Document ' }]}
            >
                <ImageUpload value={quickAccessIcon} mode="edit" onChange={(files) => setUploader(files[0])} type="single" />
            </Form.Item>
            <Form.Item  >

                <div className='submit_btn'>
                    <Space>
                        <Button type="primary" loading={actionLoader} htmlType="submit">
                            Submit
                        </Button>
                        <Button danger htmlType="button" onClick={handleCancel}>
                            Reset
                        </Button>
                    </Space>
                </div>
            </Form.Item>
        </Form >


    );

    const editProps = {
        open,
        setOpen,
        title: 'Edit  Module',
        action: 'Edit',
        content: AddForm,
        btnType: "link"

    };

    return (
        <section>
            <AddDrawer {...editProps} />
        </section>
    );
}

export default EditModule